<template>
  <div>
    <template v-if="!siteChecked">
      <template v-if="!getStarted">
        <p class="h4 mb-4">Enter your site and click next</p>
      </template>

      <c-alert v-if="error" show color="warning" close-button class="mt-4" v-html="error"></c-alert>

      <template v-if="requiresHttpAuth">
        <template v-if="isCheckingSite">
          <p class="lead mb-4">Checking your site...</p>
        </template>
        <template v-else>
          <p class="lead mb-4">We've had a quick check, and this site is protected by HTTP authentication.</p>
          <p class="lead mb-4">Please enter a HTTP authentication username and password.</p>

          <c-input
            autofocus
            class=""
            type="text"
            :lazy="true"
            :value.sync="$v.form.basicAuthUsername.$model"
            :is-valid="checkIfValid('basicAuthUsername')"
            placeholder="HTTP Auth username"
            autocomplete="off"
            invalid-feedback="Please enter a HTTP Auth username"
            :disabled="isAddingSite"
          ></c-input>

          <c-input
            class=""
            type="password"
            :lazy="true"
            :value.sync="$v.form.basicAuthPassword.$model"
            :is-valid="checkIfValid('basicAuthPassword')"
            placeholder="HTTP Auth password"
            autocomplete="off"
            invalid-feedback="Please enter a HTTP Auth password"
            :disabled="isAddingSite"
          ></c-input>
        </template>
      </template>
      <template v-else>
        <template v-if="!getStarted">
          <p class="lead mb-4">{{ isCheckingSite ? 'Checking your site...' : '' }}</p>
        </template>
        <template v-else>
          <p class="lead mb-4">
            <template v-if="isCheckingSite">Checking {{ prettyUrl }}</template>
          </p>
        </template>

        <c-input
          v-show="!getStarted"
          class=""
          type="text"
          :lazy="true"
          :value.sync="$v.form.url.$model"
          placeholder="https://yoursite.com"
          autocomplete="off"
          invalid-feedback="Please enter a valid url in the format http://yoursite.com"
          :disabled="isCheckingSite"
        ></c-input>
      </template>

      <c-row class="mt-4">
        <c-col col="12" class="text-center">
          <c-button type="submit" color="primary btn-login" class="px-4 w-100" @click="checkSite">
            <c-spinner v-if="isCheckingSite" color="success" size="sm" />
            <span v-else>Next</span>
          </c-button>
        </c-col>
      </c-row>
    </template>
    <template v-else>
      <c-form @submit.prevent="addSite">
        <template v-if="!getStarted">
          <!--          <p class="h4 mb-4">Looking good.</p>-->
          <p class="h4 mb-4">
            Please enter a WordPress admin username and password
            <span v-c-tooltip.hover="{ content: passwordHint, placement: 'bottom-start' }" class="cursor-pointer">
              <c-icon :content="freeSet.cilInfo" />
            </span>
          </p>
        </template>

        <template v-if="installStatus === 'complete'">
          <p class="lead mb-4">
            Install complete. Waiting for site...
            <c-spinner color="success" size="sm" />
          </p>
        </template>

        <template v-else-if="!isAddingSite">
          <c-alert v-if="error" show color="warning" close-button class="mt-4" v-html="error"></c-alert>

          <p v-if="getStarted" class="h4 mb-4">
            Please enter a WordPress admin username and password
            <span v-c-tooltip.hover="{ content: passwordHint, placement: 'bottom-start' }" class="cursor-pointer">
              <c-icon :content="freeSet.cilInfo" />
            </span>
          </p>

          <p class="lead mb-4">
            <template v-if="!getStarted">
              <!--              Please enter a WordPress admin username and <span style="text-decoration: underline" v-c-tooltip.hover="{content: passwordHint, placement: 'bottom-start' }">password</span>.-->
            </template>
            <template v-else>
              <!--              Finish adding your site:<br><br>{{ prettyUrl }}<br><br>-->
              <!--              Enter your WordPress login details and we'll take care of the rest.-->
            </template>
          </p>

          <template v-if="siteAddSuccess">
            <p>New site added</p>
          </template>

          <template v-else>
            <div class="">
              <!--              <CInput-->
              <!--                  v-show="!getStarted"-->
              <!--                  class=""-->
              <!--                  type="text"-->
              <!--                  readonly=""-->
              <!--                  :value="form.url"-->
              <!--              >-->
              <!--              </CInput>-->

              <c-input
                class=""
                type="text"
                :lazy="true"
                :value.sync="$v.form.wpUsername.$model"
                :is-valid="checkIfValid('wpUsername')"
                placeholder="WordPress admin username"
                autocomplete="off"
                invalid-feedback="Please enter a WordPress username"
                :disabled="isAddingSite"
              ></c-input>

              <c-input
                class=""
                type="password"
                :lazy="true"
                :value.sync="$v.form.wpPassword.$model"
                :is-valid="checkIfValid('wpPassword')"
                placeholder="WordPress admin password"
                autocomplete="off"
                invalid-feedback="Please enter a WordPress password"
                :disabled="isAddingSite"
              ></c-input>
            </div>
            <c-row class="mt-4">
              <c-col col="12" class="">
                <c-button-group v-if="!isAddingSite">
                  <template v-if="!getStarted">
                    <c-button color="secondary" @click="back">Back</c-button>
                  </template>
                  <c-button type="submit" color="primary btn-login" class="px-4 w-100">
                    <span>{{ getStarted ? "Let's go!" : 'Add new site' }}</span>
                  </c-button>
                </c-button-group>
                <c-spinner v-else color="success" size="sm" />
              </c-col>
            </c-row>
          </template>
        </template>

        <template v-else>
          <p class="lead">{{ progressText || 'Adding site' }}</p>
          <c-progress :value="installPercentage" color="success" striped :animated="true" class="mb-2" />
        </template>
      </c-form>
    </template>

    <!--      <template v-if="isAddingSite && installPercentage > 0">-->
    <!--      </template>-->
    <!--      <ul v-if="installLog.length" class="mt-3">-->
    <!--        <li v-for="log in installLog" v-html="log.log"></li>-->
    <!--      </ul>-->
  </div>
</template>

<script>
// import {buildEndpoint} from '../../../libs/buildEndPoint'
import { validationMixin } from 'vuelidate';
import { required, url } from 'vuelidate/lib/validators';
import _ from 'lodash';
import { freeSet } from '@coreui/icons';
import { buildEndpoint } from '@/libs/buildEndPoint';
import { goToPage } from '@/libs/ui/goToPage';

const maxInstallChecks = 20;
const maxFindSiteChecks = 10;

export default {
  name: 'AddANewSite',
  components: {},
  mixins: [validationMixin],
  props: {
    newSiteUrl: String,
    getStarted: Boolean,
  },
  data() {
    return {
      freeSet,
      error: null,
      siteChecked: false,
      gettingScreenshot: false,
      screenshotUrl: null,
      isCheckingSite: false,
      isAddingSite: false,
      siteAddSuccess: false,
      requiresHttpAuth: false,
      installStatusText: [
        'We are logging in now',
        'Yeah it looks good in here',
        'We are Installing that KoalaBoss goodness',
        "That's done, now let's connect it all together",
        "Wait, we're just checking it’s all good",
        "You still here? That's good",
        'OK, you ready, cause we’re almost done',
      ],
      form: {
        url: null,
        wpUsername: null,
        wpPassword: null,
        basicAuthUsername: null,
        basicAuthPassword: null,
      },
      progressText: null,
      installPercentage: 0,
      installId: null,
      installLog: [],
      installStatus: null,
      installCheckInterval: null,
      siteCheckInterval: null,
      checks: {
        install: 0,
        findSite: 0,
      },
      passwordHint:
        'KoalaBoss will temporarily use your WordPress username & password to install the KoalaBoss client plugin. We don\'t save your credentials beyond that. If you prefer, you can install the KoalaBoss client plugin yourself. Please view our <a href="https://koalaboss.com/privacy" target="_blank">privacy policy</a> on how we do this.',
    };
  },
  computed: {
    isValid() {
      return !this.$v.form.$invalid;
    },
    prettyUrl() {
      let url = this.form.url || this.newSiteUrl;
      if (url) {
        url = url.replace('http://', '').replace('https://', '');
        return url.endsWith('/') ? url.substring(0, url.length - 1) : url;
      }
    },
    url() {
      return this.form.url ? this.form.url.trim() : '';
    },
  },
  mounted() {
    if (this.getStarted && this.newSiteUrl) {
      this.form.url = this.newSiteUrl;
      this.checkSite();
    }
  },
  validations: {
    form: {
      url: {
        required,
      },
      wpUsername: {
        required,
      },
      wpPassword: {
        required,
      },
      basicAuthUsername: {
        // required,
      },
      basicAuthPassword: {
        // required,
      },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === '');
    },
    checkSite() {
      this.error = null;
      let siteAddress = this.form.url ? this.form.url.trim() : null;
      if (!siteAddress) {
        return;
      }

      if (!siteAddress.startsWith('http')) {
        this.form.url = `https://${this.form.url}`;
        siteAddress = this.form.url;
      }

      this.getScreenshot();

      const httpAuthUsername = _.trim(_.get(this.form, 'basicAuthUsername', ''));
      const httpAuthPassword = _.trim(_.get(this.form, 'basicAuthPassword', ''));

      if (this.requiresHttpAuth && (!httpAuthUsername || !httpAuthPassword)) {
        return;
      }

      this.isCheckingSite = true;

      const updateMessage = `Final step - we are ready to install our plugin into ${this.prettyUrl}.`;

      setTimeout(() => {
        const data = {
          siteAddress,
          httpAuthUsername,
          httpAuthPassword,
        };
        this.$http
          .post(buildEndpoint('site/check/site'), data)
          .then((response) => {
            this.isCheckingSite = false;
            if (response.data.success) {
              this.siteChecked = true;
              this.$emit('update:message', updateMessage);
              this.$emit('screenshotUrl', this.screenshotUrl);
              this.$emit('step', 2);
            } else {
              const statusCode = _.get(response.data, 'data.status');
              // Requires HTTP auth
              if (statusCode === 401) {
                if (this.requiresHttpAuth) {
                  this.error = "We couldn't login to your site with the HTTP authentication username & password you provided. Can you please check and try again?";
                }
                this.requiresHttpAuth = true;
                return;
              }
              this.error = `${response.data.message}${response.data.error ? `: ${response.data.error}` : ''}`;
            }
          })
          .catch((error) => {
            this.isCheckingSite = false;
            this.error = error;
          });
      }, 0);
    },
    checkInstallStatus() {
      this.error = null;
      this.$http
        .get(buildEndpoint(`site/check/install/${this.installId}`))
        .then((response) => {
          const { data } = response.data;
          this.installLog = data.installLog || [];
          this.progressText = this.installStatusText[data.installLog.length];
          const installSteps = data.installLog.length;
          this.installPercentage = (installSteps / 6) * 100;
          this.installStatus = data.installStatus;

          this.checks.install += 1;
          if (this.checks.findSite > maxInstallChecks) {
            this.error = 'There was a problem adding this site';
            this.installStatus = 'failed';
            clearInterval(this.installCheckInterval);
          }

          if (this.installStatus === 'complete') {
            clearInterval(this.installCheckInterval);
            this.isAddingSite = false;
            this.findNewSite();
          }
          if (this.installStatus === 'failed') {
            clearInterval(this.installCheckInterval);
            this.isAddingSite = false;
            const error = _.last(data.installLog).log;
            if (error === 'Plugin install failed: Could not login') {
              this.error = "We couldn't login to your site with the username & password you provided. Can you please check and try again?";
            } else {
              this.error = error;
            }
          }
        })
        .catch((error) => {
          clearInterval(this.installCheckInterval);
          this.error = error;
        });
    },
    findNewSite() {
      this.error = null;
      this.siteCheckInterval = setInterval(() => {
        this.$http
          .get(buildEndpoint(`site/find-new/${this.installId}`))
          .then((response) => {
            this.checks.findSite += 1;
            if (this.checks.findSite > maxFindSiteChecks) {
              this.error = 'There was a problem adding this site';
              this.installStatus = 'failed';
              clearInterval(this.siteCheckInterval);
            }
            if (response.data.success) {
              // eslint-disable-next-line no-underscore-dangle
              const { _id: siteId } = response.data.data;
              if (siteId) {
                this.siteAddSuccess = true;
                clearInterval(this.siteCheckInterval);
                goToPage(this.$router, { name: 'detailsSite', params: { siteId } });
              }
            } else {
              clearInterval(this.siteCheckInterval);
              this.error = `${response.data.message}${response.data.error ? `: ${response.data.error}` : ''}`;
            }
          })
          .catch((error) => {
            clearInterval(this.siteCheckInterval);
            this.error = error;
          });
      }, 2000);
    },
    addSite() {
      this.error = null;
      this.installLog = [];
      this.progressText = null;
      this.installPercentage = 0;
      this.$v.$touch();
      if (this.isValid) {
        this.isAddingSite = true;

        const basicAuthUsername = _.trim(_.get(this.form, 'basicAuthUsername', ''));
        const basicAuthPassword = _.trim(_.get(this.form, 'basicAuthPassword', ''));
        const wpUsername = _.trim(_.get(this.form, 'wpUsername', ''));
        const wpPassword = _.trim(_.get(this.form, 'wpPassword', ''));

        if (this.requiresHttpAuth && (!basicAuthUsername || !basicAuthPassword)) {
          return;
        }

        setTimeout(() => {
          const data = {
            siteAddress: this.form.url.trim(),
            wpUsername,
            wpPassword,
            basicAuthUsername,
            basicAuthPassword,
            screenshotUrl: this.screenshotUrl,
          };
          this.$http
            .post(buildEndpoint('site/add'), data)
            .then((response) => {
              if (response.data.success) {
                this.installId = response.data.data.installId;
                if (this.installId) {
                  // Trigger install
                  this.install();
                  // Track install
                  this.installCheckInterval = setInterval(() => {
                    this.checkInstallStatus();
                  }, 3000);
                }
              } else {
                this.isAddingSite = false;
                this.error = `${response.data.message}${response.data.error ? `: ${response.data.error}` : ''}`;
              }
            })
            .catch((error) => {
              this.isAddingSite = false;
              this.error = error;
            });
        }, 0);
      }
    },
    resetInstall() {
      this.progressText = null;
      this.installStatus = null;
    },
    install() {
      this.resetInstall();
      this.progressText = this.installStatusText[0];
      this.$http
        .get(buildEndpoint(`site/install/${this.installId}`))
        .then((response) => {
          // clearInterval(this.installCheckInterval)
          // this.checkInstallStatus()
          if (response.data.success) {
            // console.log('Install initiated')
            // this.installId = response.data.installId;
            // this.siteAddSuccess = true;
            // goToPage(this.$router, {name: 'detailsSite', params: {siteId: response.data.data._id}})
          } else {
            // this.error = `${response.data.message}${response.data.error ? ': ' + response.data.error : ''}`
            this.error = 'We couldn\'t install the plugin on this site. Please try again or try adding the site manually.';
          }
        })
        .catch((error) => {
          // this.isAddingSite = false
          this.error = error;
        });
    },
    getScreenshot() {
      this.gettingScreenshot = true;
      this.$http
        .get(`${process.env.VUE_APP_KOALABOSS_SCREENSHOT_API}/screenshot/url/desktop?url=${this.url}`)
        .then((response) => {
          this.gettingScreenshot = false;
          if (!response.data.success) {
            this.error = error.response.data.message;
          }
          this.screenshotUrl = _.get(response, 'data.data.s3ImageUrl');
        })
        .catch((error) => {
          this.error = error.response.data.message;
          this.gettingScreenshot = false;
        });
    },
    back() {
      this.siteChecked = false;
      this.error = null;
      this.$emit('update:message', '');
      this.$emit('screenshotUrl', '');
      this.$emit('step', 1);
    },
  },
};
</script>
